import { FC } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { CbTableSearchbar } from '../CbTable/CbTableSearchbar';
import { CbFilterBox } from '../CbFilterBox';
export interface CbDirectorySearchProps {
  activeFilters: string[] | null;
  dropdownFilters: string[];
  handleSearchFilter: (search: string) => void;
  handleActiveFilterChange: (filters: string[]) => void;
}
export const CbDirectorySearch: FC<CbDirectorySearchProps> = ({
  activeFilters,
  dropdownFilters,
  handleSearchFilter,
  handleActiveFilterChange
}) => {
  const onTextSearch = (searchQuery: string) => {
    handleSearchFilter(searchQuery);
  };
  return <Box background="white" padding={6} borderRadius={24} boxShadow="standardCard" width="xs" data-sentry-element="Box" data-sentry-component="CbDirectorySearch" data-sentry-source-file="CbDirectorySearch.tsx">
      <Text fontFamily="codenext" color="text.primary" fontSize="lg" marginBottom={4} data-sentry-element="Text" data-sentry-source-file="CbDirectorySearch.tsx">
        {'Filter & Search'}
      </Text>
      <CbTableSearchbar onTextFilterChange={text => onTextSearch(text)} backgroundColor="cloud.100" borderColor="cloud.300" width={{
      md: '235px'
    }} marginBottom={6} data-sentry-element="CbTableSearchbar" data-sentry-source-file="CbDirectorySearch.tsx" />
      <CbFilterBox staleFilters={activeFilters} handleActiveFilterChange={handleActiveFilterChange} dropdownFilters={dropdownFilters} data-sentry-element="CbFilterBox" data-sentry-source-file="CbDirectorySearch.tsx" />
    </Box>;
};